/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateCoinResponseData } from './CreateCoinResponseData';
import {
    CreateCoinResponseDataFromJSON,
    CreateCoinResponseDataFromJSONTyped,
    CreateCoinResponseDataToJSON,
} from './CreateCoinResponseData';

/**
 * 
 * @export
 * @interface CreateCoinResponse
 */
export interface CreateCoinResponse {
    /**
     * 
     * @type {CreateCoinResponseData}
     * @memberof CreateCoinResponse
     */
    data?: CreateCoinResponseData;
}

/**
 * Check if a given object implements the CreateCoinResponse interface.
 */
export function instanceOfCreateCoinResponse(value: object): value is CreateCoinResponse {
    let isInstance = true;

    return isInstance;
}

export function CreateCoinResponseFromJSON(json: any): CreateCoinResponse {
    return CreateCoinResponseFromJSONTyped(json, false);
}

export function CreateCoinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCoinResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CreateCoinResponseDataFromJSON(json['data']),
    };
}

export function CreateCoinResponseToJSON(value?: CreateCoinResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateCoinResponseDataToJSON(value.data),
    };
}

